import { Injectable, DOCUMENT, inject } from '@angular/core';
import { MessageDialogConfig } from './message-dialog-config.interface';
import { MessageDialogComponent } from './message-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root'
})
export class MessageDialogService {
    private document = inject<Document>(DOCUMENT);
    private matDialog = inject(MatDialog);

    public showDialog(config: MessageDialogConfig): void {
        const dialogRef = this.matDialog.open(MessageDialogComponent, {
            width: '508px',
            panelClass: 'ca-dialog',
            data: { ...config }
        });

        dialogRef.afterClosed().subscribe(() => (this.document.activeElement as HTMLElement)?.blur());
    }
}
